
import { useEffect, useState } from "react";

import { Grid, Card, CardHeader, Typography, Divider, CardContent, Button, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, TablePagination, Tooltip, IconButton, Badge, Chip, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from "@mui/material";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { AiOutlineOrderedList, AiOutlineFileText } from "react-icons/ai";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

import moment from "moment";

import { usePages } from "../../../hooks/usePages";

import { TablePaginationActions } from "../../../helpers/TablePaginationActions";

import { TableTheadStyle, TablePaddingStyle } from "../../../styles/TableStyle";

import { Layout } from "../../../components/Layout";

import { DialogDocumento } from "../../../dialogs/DialogDocumento";

import { BuscarListadoEntrega } from "../../../connections/comun/ListadoEntregaConnection";

import { ListadoEntregaProps, ListadoEntregaRecepcionProps } from "../../../interfaces/comun/ListadoEntregaInterface";

export const ConsultarListadoEntregaPage = () => {

    const [rows, setRows] = useState<ListadoEntregaProps[]>( [] );
    const [recordsCount, setRecordsCount] = useState( 0 );

    const [loading, setLoading] = useState( false );

    const [recepciones, setRecepciones] = useState<ListadoEntregaRecepcionProps[]>( [] );
    const [openRecepciones, setOpenRecepciones] = useState( false );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [fechaInicio, setFechaInicio] = useState<moment.Moment | null>( moment() );
    const [fechaFin, setFechaFin] = useState<moment.Moment | null>( moment() );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(10);
    const { page: pageRecepciones, rowsPerPage: rowsPerPageRecepciones, handleChangePage: handleChangePageRecepciones, handleChangeRowsPerPage: handleChangeRowsPerPageRecepciones } = usePages(10);

    const handleBuscar = () => {

        setFiltroAplicado( true );
        resetPage();

    };

    const handleLimpiar = () => {

        setFiltroAplicado( false );
        setFechaInicio( moment() );
        setFechaFin( moment() );

        setRows( [] );
        setRecordsCount( 0 );
        resetPage();

    };

    useEffect(() => {

        if ( !filtroAplicado || !fechaInicio || !fechaFin ) return;

        setLoading( true );
        setRows( [] );

        BuscarListadoEntrega({ fechaInicio: fechaInicio.format('YYYY-MM-DD'), fechaFin: fechaFin.format('YYYY-MM-DD'), page, rowsPerPage }).then( resp => {

            setTimeout(() => {

                setRows( resp.listadosEntrega ?? [] );
                setRecordsCount( resp.recordsCount ?? 0 );
                setLoading( false );

            }, 700);

        });

    }, [ filtroAplicado, page, rowsPerPage, fechaInicio, fechaFin ]);

    return (
        <Layout breadcrumbs={[{ text: 'Listado de entrega' }, { text: 'Consultar listados de entrega' }]} backgroundPaper={ false }>

            <Grid container spacing={3}>

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={3}>

                                <Grid size={{ xs: 12, md: 5 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment }>

                                        <DatePicker
                                            label="Fecha de inicio"
                                            sx={{ width: '100%' }}
                                            value={ fechaInicio }
                                            onChange={ (v) => setFechaInicio(v) }
                                            maxDate={ moment() }
                                            disabled={ filtroAplicado }
                                        />

                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ xs: 12, md: 5 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment }>

                                        <DatePicker
                                            label="Fecha de finalización"
                                            sx={{ width: '100%' }}
                                            value={ fechaFin }
                                            onChange={ (v) => setFechaFin(v) }
                                            maxDate={ moment() }
                                            disabled={ filtroAplicado }
                                        />

                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ xs: 12, md: 2 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'inherit' : 'primary' }
                                        variant='contained'
                                        disabled={ loading || !fechaInicio || !fechaFin }
                                        onClick={ filtroAplicado ? handleLimpiar : handleBuscar }
                                    >
                                        { filtroAplicado ? 'Limpiar' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Fecha</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%', fontWeight: 'bold' }}>Usuario generó</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Ver trámites</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Ver listado de entrega</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map(({ documento, fecha, idListadoEntrega, recepcion, usuarioGenero }, index) => (

                                        <TableRow key={index}>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant="subtitle1">
                                                    <strong>{ 'GLE-' + idListadoEntrega }</strong>
                                                </Typography>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1'>
                                                    { moment( fecha ).format('DD-MM-YYYY') }
                                                </Typography>
                                                <Typography variant='caption' color='text.secondary'>
                                                    { moment( fecha ).format('hh:mm a') }
                                                </Typography>

                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1' fontSize={14}>{usuarioGenero}</Typography>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Tooltip title='Visualizar tramites recibidos'>

                                                    <IconButton color="primary" onClick={() => { setRecepciones(recepcion); setOpenRecepciones(true); }}>
                                                        <Badge
                                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                                            badgeContent={<Typography variant="subtitle2">{recepcion.length}</Typography>}
                                                            color="secondary"
                                                        >
                                                            <AiOutlineOrderedList fontSize={28} />
                                                        </Badge>
                                                    </IconButton>

                                                </Tooltip>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Tooltip title='Visualizar listado de entrega'>

                                                    <IconButton color="primary" onClick={() => {
                                                        setDocumento(documento);
                                                        setOpenDocumento(true);
                                                    }}>
                                                        <AiOutlineFileText fontSize={28} />
                                                    </IconButton>

                                                </Tooltip>

                                            </TableCell>

                                            <TableCell>

                                                {
                                                    documento 
                                                    &&
                                                        <Chip
                                                            variant="filled"
                                                            color="primary"
                                                            sx={{ width: '100%', py: 3 }}
                                                            label={
                                                                <>
                                                                    <Typography variant="subtitle2">Entregado</Typography>
                                                                    <Typography variant="caption">{ moment(fecha).format( 'DD-MM-YYYY' ) }</Typography>
                                                                </>
                                                            }
                                                        />
                                                }

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>

                                            <TableCell colSpan={7} align='center'>

                                                <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>

                                                <TableCell colSpan={7} align='center'>

                                                    <CircularProgress size={26} />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={2}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>Total de registros: {recordsCount}</Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={[100, 50, 20, 15, 10, 5]}
                                        colSpan={10}
                                        count={recordsCount}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

                <DialogDocumento
                    documento={ documento }
                    openDialog={ openDocumento}
                    handleCloseDialog={ () => setOpenDocumento( false ) }
                />

                <Dialog 
                    fullWidth
                    maxWidth="xl" 
                    open={ openRecepciones } 
                    onClose={ () => {} }
                >

                    <DialogTitle>Tramites recibido(s)</DialogTitle>

                    <DialogContent>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                                <Table sx={{ minWidth: 500 }}>

                                    <TableHead sx={{ ...TableTheadStyle }}>

                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Tipo de trámite</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Escrito</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Acuse</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}></TableCell>

                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        {
                                            (
                                                rowsPerPageRecepciones > 0 
                                                ?
                                                    recepciones.slice( pageRecepciones * rowsPerPageRecepciones, pageRecepciones * rowsPerPageRecepciones + rowsPerPageRecepciones )                                                
                                                :
                                                    recepciones
                                            )
                                            .map(({ numeroSeguimiento, fecha, referencia, materia, noReferencia, tipoTramite, subTipoTramite, folioBuzonElectronico, acuse, escrito, selected }, index) => (

                                                <TableRow key={index} >

                                                    <TableCell>

                                                        <Typography variant='subtitle1'>
                                                            <strong>{ numeroSeguimiento }</strong>
                                                        </Typography>

                                                        { fecha && <Typography variant='subtitle1' fontSize={14}>{ moment( fecha ).format( 'DD-MM-YYYY a' ) } </Typography> }

                                                    </TableCell>

                                                    <TableCell sx={{ textAlign: 'center' }}>

                                                        {
                                                            ( noReferencia && referencia )
                                                            ?
                                                                <>
                                                                    <Typography variant='subtitle1'><strong>{referencia}</strong></Typography>
                                                                    <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>{ noReferencia }</Typography>

                                                                    <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>({ materia })</Typography>
                                                                </>
                                                            :
                                                                <>
                                                                    <Typography variant='subtitle1'><strong>{ referencia }</strong></Typography>

                                                                    {
                                                                        referencia && <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>({ materia })</Typography>
                                                                    }

                                                                </>
                                                        }

                                                    </TableCell>

                                                    <TableCell>

                                                        <Typography variant='subtitle1'>
                                                            <strong>{ tipoTramite }</strong>
                                                        </Typography>

                                                        {
                                                            subTipoTramite && <Typography variant='subtitle1' fontSize={14}>{ subTipoTramite } </Typography>
                                                        }

                                                    </TableCell>

                                                    <TableCell sx={{ textAlign: 'center' }} >

                                                        {
                                                            escrito
                                                            &&
                                                                <Button
                                                                    fullWidth
                                                                    variant='contained'
                                                                    sx={{ textTransform: 'none' }}
                                                                    onClick={() => { setOpenDocumento( true ); setDocumento( escrito ); }}
                                                                >
                                                                    Ver escrito
                                                                </Button>
                                                        }

                                                    </TableCell>

                                                    <TableCell sx={{ textAlign: 'center' }} >

                                                        {
                                                            acuse
                                                            &&
                                                                <Button
                                                                    fullWidth
                                                                    variant='contained'
                                                                    sx={{ textTransform: 'none' }}
                                                                    onClick={() => { setOpenDocumento( true ); setDocumento( acuse ); }}
                                                                >
                                                                    Ver acuse
                                                                </Button>
                                                        }

                                                    </TableCell>

                                                    <TableCell>

                                                        {
                                                            folioBuzonElectronico
                                                            &&
                                                                <Chip
                                                                    variant='outlined'
                                                                    color='secondary'
                                                                    sx={{ p: 2 }}
                                                                    icon={ <ForwardToInboxIcon fontSize='small' /> }
                                                                    label={
                                                                        <Typography variant='button' fontWeight={'600'} sx={{ ml: 1 }}>
                                                                            { folioBuzonElectronico }
                                                                        </Typography>
                                                                    }
                                                                />
                                                        }

                                                    </TableCell>

                                                </TableRow>

                                            ))
                                        }

                                        {
                                            recepciones.length === 0
                                            &&
                                                <TableRow style={{ height: 100 }}>

                                                    <TableCell colSpan={7} align='center'>

                                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                                    </TableCell>

                                                </TableRow>
                                        }

                                    </TableBody>

                                    <TableFooter>

                                        <TableRow>

                                            <TableCell colSpan={2}>
                                                <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de trámites: { recepciones.length } </Typography>
                                            </TableCell>

                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                                                colSpan={10}
                                                count={recepciones.length}
                                                rowsPerPage={rowsPerPageRecepciones}
                                                page={pageRecepciones}
                                                onPageChange={handleChangePageRecepciones}
                                                onRowsPerPageChange={handleChangeRowsPerPageRecepciones}
                                                ActionsComponent={TablePaginationActions}

                                                labelRowsPerPage='Filas por página'
                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                        return '' + from + '-' + to + ' de ' + count
                                                    }
                                                }
                                            />

                                        </TableRow>

                                    </TableFooter>

                                </Table>

                            </TableContainer>

                        </Grid>

                    </DialogContent> 

                    <DialogActions>

                        <Button color='secondary' onClick={() => { setOpenRecepciones( false ); setRecepciones( [] ); }}>
                            Cerrar
                        </Button>

                    </DialogActions>

                </Dialog>

            </Grid>

        </Layout>
    )
}
